import { CountryCode, Currency, Locale, LocaleLowerCase } from '../types/locale'
import { useLocation } from 'react-router-dom'
import { getCountry } from '../utils/checkout'
import { countryToCurrencyMap, getLocale } from '../utils/locale'

export interface UseLocale {
  countryCode: CountryCode
  locale: Locale
  currency: Currency
  lowerCaseLocale: LocaleLowerCase
}

export function useLocale(): UseLocale {
  const hostname = window.location.hostname
  const countryCode = getCountry(hostname)

  const route = useLocation().pathname
  const locale = getLocale(route)
  const lowerCaseLocale = locale.toLowerCase() as LocaleLowerCase

  const currency: Currency = countryToCurrencyMap[countryCode]

  return {
    countryCode,
    locale,
    currency,
    lowerCaseLocale,
  }
}
